import { useGetMessageBarsQuery } from '../../store/api/message-bar-api'
import dayjs from 'dayjs'
import { FC, useEffect, useMemo, useState } from 'react'
import styled from 'styled-components'
import { Filters } from '../../types/strapi/strapi'

const MESSAGE_BAR_POLLING_INTERVAL_MS = 5 * 60 * 1000
const MESSAGE_ROTATION_INTERVAL_MS = 15 * 1000

const MessageBarContainer = styled.div`
    flex: 0 0 40px;
    width: 100%;
    height: 20px;
    background-color: #F3AD1E;
    overflow: hidden;
    box-sizing: border-box;
`
const MessageBarText = styled.div`
    color: white;
    font-weight: bold;
    font-size: 18px;
    line-height: 40px;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 0 8px;
`
const getMessageBarFilter = (today: dayjs.Dayjs): Filters => {
    return {
        timeStart: { $lte: today.endOf('day').toISOString() },
        timeEnd: { $gte: today.startOf('day').toISOString() },
    }
}
export const MessageBar: FC = () => {
    const today = dayjs()
    const messageBarFilter = useMemo(() => getMessageBarFilter(today), [today])
    const { data } = useGetMessageBarsQuery(messageBarFilter, {
        pollingInterval: MESSAGE_BAR_POLLING_INTERVAL_MS,
    })
    const [messageIndex, setMessageIndex] = useState(0)
    const visibleMessages = (data?.data ?? []).filter(message => {
        const timeStart = new Date(message.timeStart).getTime()
        const timeEnd = new Date(message.timeEnd).getTime()

        return timeStart < Date.now() && timeEnd > Date.now()
    })

    useEffect(() => {
        if (visibleMessages.length < 2) return

        const timer = window.setInterval(() => {
            setMessageIndex(index => index + 1)
        }, MESSAGE_ROTATION_INTERVAL_MS)

        return () => window.clearInterval(timer)
    }, [visibleMessages.length])

    if (visibleMessages.length === 0) return null

    const currentMessage = visibleMessages[messageIndex % visibleMessages.length]

    return (
        <MessageBarContainer>
            <MessageBarText>{currentMessage.text}</MessageBarText>
        </MessageBarContainer>
    )
}
